// src/components/PrivacyPolicy.js
import React from 'react';
import { Box, Heading, Text, Stack, Divider, Button } from '@chakra-ui/react';

const PrivacyPolicy = () => {
  return (
    <Box p={5} maxW="800px" mx="auto" borderWidth={1} borderRadius="md" boxShadow="lg">
      <Heading as="h1" size="xl" mb={5} textAlign="center">
        Privacy Policy
      </Heading>

      <Stack spacing={4}>
        <Text fontSize="lg" fontWeight="bold">📥 1. Information Collection</Text>
        <Text>
          We may collect personal information from users when they interact with our website, submit forms, or engage with our consultancy services.
          This information may include, but is not limited to, names, contact details, academic records, and other relevant details necessary for the admission process.
        </Text>

        <Text fontSize="lg" fontWeight="bold">📊 2. Use of Information</Text>
        <Text>
          Admission Possibility may use the collected information for the following purposes:
        </Text>
        <Stack spacing={2} pl={5}>
          <Text>📌 Facilitating the admission process to medical colleges.</Text>
          <Text>📌 Providing personalized consultancy services.</Text>
          <Text>📌 Sending relevant updates and notifications.</Text>
          <Text>📌 Improving our services based on user feedback.</Text>
        </Stack>

        <Text fontSize="lg" fontWeight="bold">🔄 3. Information Sharing</Text>
        <Text>
          We do not sell, trade, or rent users' personal information. However, we may share information with trusted third parties who assist us in operating our website or conducting our business, 
          provided they agree to keep the information confidential.
        </Text>

        <Text fontSize="lg" fontWeight="bold">🛡️ 4. Security Measures</Text>
        <Text>
          Admission Possibility employs industry-standard security measures to protect against unauthorized access, alteration, disclosure, or destruction of personal information.
          However, no method of transmission over the internet or electronic storage is entirely secure, and we cannot guarantee absolute security.
        </Text>

        <Text fontSize="lg" fontWeight="bold">✏️ 5. User Control</Text>
        <Text>
          Users have the right to access, modify, or delete their personal information. They can contact us at contact@admissionpossibility.com to make such requests.
        </Text>

        <Text fontSize="lg" fontWeight="bold">🍪 6. Cookies and Tracking</Text>
        <Text>
          Admission Possibility may use cookies and similar tracking technologies to enhance user experience. Users can adjust their browser settings to refuse cookies or receive notifications when cookies are being sent.
          Please note that disabling cookies may affect the functionality of some parts of our website.
        </Text>

        <Text fontSize="lg" fontWeight="bold">👶 7. Children's Privacy</Text>
        <Text>
          Admission Possibility does not knowingly collect personal information from children under the age of 13. If you believe that we have inadvertently collected such information, please contact us,
          and we will take steps to delete it.
        </Text>

        <Text fontSize="lg" fontWeight="bold">📅 8. Changes to Privacy Policy</Text>
        <Text>
          Admission Possibility reserves the right to update this Privacy Policy. Users are encouraged to review this page periodically for changes. By continuing to use our services after any modifications, 
          users acknowledge and agree to the updated terms.
        </Text>

        <Text fontSize="lg" fontWeight="bold">📧 9. Contact Information</Text>
        <Text>
          For any questions or concerns regarding this Privacy Policy, users can contact Admission Possibility at contact@admissionpossibility.com.
        </Text>

        <Text fontSize="sm" color="gray.500" mt={5}>
          📌 This Privacy Policy is effective as of January 2024 and was last updated on January 2024.
        </Text>

        <Divider my={6} />

        {/* <Button colorScheme="teal" width="full" onClick={() => alert('You acknowledged the privacy policy!')}>
          I Acknowledge
        </Button> */}
      </Stack>
    </Box>
  );
};

export default PrivacyPolicy;

// import React from "react";
// import { Box } from "@chakra-ui/react"

// const PrivacyPolicy=()=>{
//     return(
//         <Box>PrivacyPolicy</Box>
//     )
// }

// export default PrivacyPolicy